/** Reserve a marker slot so projected and measured values stay aligned. */
export function ProjectedValue({ projected, children }) {
  return (
    <span className="inline-flex items-baseline justify-end">
      <span className="tabular-nums">{children}</span>
      <span
        className="w-2.5 self-start text-left text-[9px] leading-none text-muted-foreground"
        title={projected === null ? '实测或外推状态未知' : undefined}
      >
        {projected === null ? '?' : projected ? '预' : ''}
      </span>
    </span>
  )
}
